import { createAction, props } from '@ngrx/store';
import { Category } from '../model/category.model';

export const LOAD_CATEGORY_FAIL = createAction('[Category] - ERROR in Category', props<Error>());

export const LOAD_CATEGORY = createAction('[Category] - Get Category', props<{ payload: string }>());

export const LOAD_CATEGORY_SUCCESS = createAction('[Category] - Success Get Category', props<{ payload: Category }>());
